import { get } from '@rails/request.js';
import FormController from './../components/form_controller';

import Dropdown from './../components/dropdown_controller';

export default class extends FormController {

  static targets = ['form', 'asIsInput', 'asIsSection', 'createVariantLink', 'applyDecorationButton'];
  static outlets = ['dropdown'];
  static values = {
    decorationUrl: String,
    basePriceTableUrl: String,
    filterProductTypesUrl: String,
  };
  initialFormData = {};

  // eslint-disable-next-line no-unused-vars
  dropdownBlur(e) {

    const dropdown = e.detail.dropdown;

    if (dropdown.initializing || !e.detail.wasChanged) return;

    // TODO May no longer be needed
    if (dropdown.id === 'product-type') {
      const selection = dropdown.getSelection() || '';
      get(`${dropdown.streamValue}?product_type=${selection.value}`, {
        contentType: 'application/json',
        responseKind: 'turbo-stream',
      }).then(() => {
        dropdown.updateDependent(Dropdown.events.reload, { enable: selection !== '' });
      });

      if (this.hasCreateVariantLinkTarget) {
        // Inform the create variant link about the selected product type
        const url = new URL(this.createVariantLinkTarget.href, window.location.origin);
        url.searchParams.set('product_type', selection.value);
        this.createVariantLinkTarget.href = url.toString();
      }
    }
  }

  toggleUpload(e) {
    const checked = e.target.checked;
    const upchargeField = this.getInputControllerByName('upload_charge');

    if (!upchargeField) return;

    if (checked) {
      upchargeField.setRequired(true);
      upchargeField.show();
    } else {
      upchargeField.setRequired(false);
      upchargeField.hide();
      upchargeField.clearError();
    }
  }

  validate(e) {
    let valid = super.validate(e);

    if (!valid) {
      this.formTarget.querySelector('.error')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return valid;
  }

  updateProductTypes(e) {
    const value = encodeURIComponent(e.target.value);
    const url = this.filterProductTypesUrlValue;
    get(`${url}?decopac_offering=${value}`, {
      contentType: 'application/json',
      responseKind: 'turbo-stream',
    }).catch((error) => {
      console.error(error);
    });
  }
}
